import store from '../store/index'
import { createRouter, createWebHistory } from 'vue-router';
import { resolveModeratorNavigation } from '@/utils/moderatorAuth';
import { isJwtExpired, resolveAuthGate } from '@/utils/authSession';

import homePage from '../views/Home.vue'
const loginPage = () => import('../views/Login.vue')
const registerPage = () => import('../views/Register.vue')
const NewletterPage = () => import('../views/NewsLetter.vue')

const CategoryFeed = () => import('../views/CategoryFeed.vue')
import ArticleService from '../services/ArticleService';
import NbaScores from '../components/NbaScores.vue';
import NflIntelligencePreview from '../components/NflIntelligencePreview.vue';
import NhlScores from '../components/NhlScores.vue';
import UfcScores from '../components/UfcScores.vue';
const Logout = () => import('../views/Logout.vue')
const politicsPage = () => import('../views/Politics.vue')
const PoliticalIntelligenceBrief = () => import('../views/PoliticalIntelligenceBrief.vue')
const inTheaters = () => import('../views/InTheaters.vue')
const profilePage = () => import('../views/Profile.vue')
const theCommunityPage = () => import('../views/TheCommunity.vue')
const ArticleContent = () => import('../views/ArticleContent.vue')
const TrendingMobile = () => import('../views/TrendingMobile.vue')
const BoxScore = () => import('../components/NbaBoxScore.vue')
const NbaBoxScorePage = () => import('../views/NbaBoxScorePage.vue')
const NhlBoxScorePage = () => import('../views/NhlBoxScorePage.vue')
const SearchArticlesMobile = () => import('../components/SearchArticlesMobile')
const SearchArticlesDesktop = () => import('../components/SearchForArticlesDesktop')
const imagesRender = () => import('../components/Images')
const Thought = () => import('../views/Thought.vue')
const RssFeed = () => import('../views/RssFeed')
const NotFoundPage = () => import('../views/NotFound404')
const ForgetPassword = () => import('../views/ForgetPassword')
const UpdatePassword = () => import('../views/UpdatePassword')
const NotificationCenter = () => import('../views/NotificationCenter')
const PricingPage = () => import('../views/Pricing.vue')
const SubscriptionSuccess = () => import('../views/SubscriptionSuccess.vue')
const CommunityProfile = () => import('../views/CommunityProfile.vue')
const AboutPage = () => import('../views/About.vue')
const MethodologyPage = () => import('../views/Methodology.vue')
const UnderSniperPage = () => import('../views/UnderSniper.vue')
const SniperPicksPage = () => import('../views/SniperPicks.vue')
const EditorialPolicyPage = () => import('../views/EditorialPolicy.vue')
const PrivacyPolicyPage = () => import('../views/PrivacyPolicy.vue')
const TermsOfServicePage = () => import('../views/TermsOfService.vue')
const CommunityGuidelinesPage = () => import('../views/CommunityGuidelines.vue')
const HowSentimentWorksPage = () => import('../views/HowSentimentWorks.vue')
const HowBiasWorksPage = () => import('../views/HowBiasWorks.vue')
const HowBlindspotWorksPage = () => import('../views/HowBlindspotWorks.vue')
const ChallengeYourViewPage = () => import('../views/ChallengeYourView.vue')
const UfcHomePage = () => import('../views/ufc/UfcHome.vue')
const UfcEventsPage = () => import('../views/ufc/UfcEvents.vue')
const UfcEventCenterPage = () => import('../views/ufc/UfcEventCenter.vue')
const UfcFightCenterPage = () => import('../views/ufc/UfcFightCenter.vue')
const UfcFighterProfilePage = () => import('../views/ufc/UfcFighterProfile.vue')
const UfcRankingsPage = () => import('../views/ufc/UfcRankings.vue')
const NflHomePage = () => import('../views/nfl/NflHome.vue')
const NflGamesPage = () => import('../views/nfl/NflGames.vue')
const NflGameCenterPage = () => import('../views/nfl/NflGameCenter.vue')
const NflTeamProfilePage = () => import('../views/nfl/NflTeamProfile.vue')
const NflPlayerProfilePage = () => import('../views/nfl/NflPlayerProfile.vue')
const NflStandingsPage = () => import('../views/nfl/NflStandings.vue')
const NflPowerRankingsPage = () => import('../views/nfl/NflPowerRankings.vue')
const YourSportsPage = () => import('../views/YourSports.vue')
const YourSportsManagePage = () => import('../views/YourSportsManagePage.vue')
const AccountSettingsPage = () => import('../views/Settings.vue')

    const routes = [
        {
            path: '/',
            name: 'home',
            component: homePage,
            meta: { persistScroll: true }
        },
        {
            path: '/trending',
            name: 'TrendingPage',
            component: TrendingMobile
        },
        {
            path: '/business',
            name: 'business',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listBusinessArticles,
                heading: 'Business News Feed',
                headingIcon: 'fa fa-solid fa-briefcase',
                sentimentCategory: 'business',
                label: 'Business',
                seoTitle: 'Business News Feed | Barbershop Talk',
                seoDescription: "The Business News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Business! Explore trending Business insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Business News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Business! Explore trending Business insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/technology',
            name: 'technology',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listTechnologyArticles,
                heading: 'Technology News Feed',
                headingIcon: 'fa fa-solid fa-microchip',
                sentimentCategory: 'technology',
                label: 'Technology',
                seoTitle: 'Technology News Feed | Barbershop Talk',
                seoDescription: 'AI, model, and tech news with sentiment and multi-source coverage — Barbershop Talk.',
                seoTwitterDescription: 'AI and tech news with every angle in one feed. Sentiment pulse and story coverage, no filter.',
            })
        },
        {
            path: '/the-barbershop',
            name: 'theCommunity',
            component: theCommunityPage
        },
        {
            path: '/politics',
            name: 'politics',
            component: politicsPage
        },
        {
            path: '/politics/intelligence',
            name: 'political-intelligence',
            component: PoliticalIntelligenceBrief
        },
        {
            path: '/politics/right-wing',
            name: 'right-wing',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listRightWingArticles,
                heading: 'Right Wing News Feed',
                headingIcon: 'fa fa-solid fa-republican',
                sentimentCategory: 'politics',
                label: 'Right Wing',
                politicsMode: true,
                seoTitle: 'Right Wing News Feed | Barbershop Talk',
                seoDescription: "The Right Wing News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Politics! Explore trending Right Wing insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Right Wing News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Right Wing Politics! Explore trending insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/politics/left-wing',
            name: 'left-wing',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listLeftWingArticles,
                heading: 'Left Wing News Feed',
                headingIcon: 'fa fa-solid fa-democrat',
                sentimentCategory: 'politics',
                label: 'Left Wing',
                politicsMode: true,
                seoTitle: 'Left Wing News Feed | Barbershop Talk',
                seoDescription: "The Left Wing News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Politics! Explore trending Left Wing insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Left Wing News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Left Wing Politics! Explore trending insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/politics/center',
            name: 'center',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listCenterArticles,
                heading: 'Center News Feed',
                headingIcon: 'fa fa-solid fa-scale-balanced',
                sentimentCategory: 'politics',
                label: 'Center',
                politicsMode: true,
                seoTitle: 'Center News Feed | Barbershop Talk',
                seoDescription: "The Center News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Politics! Explore trending Center insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Center News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Center Politics! Explore trending insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/movies',
            name: 'movies',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listMovieArticles,
                heading: 'Movie News Feed',
                headingIcon: 'fa fa-solid fa-film',
                sentimentCategory: 'movies',
                label: 'Movies',
                seoTitle: 'Movie News Feed | Barbershop Talk',
                seoDescription: "The Movie News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Movies and Entertainment! Explore trending Movie insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Movie News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Movies! Explore trending Movie insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/tvNews',
            name: 'television',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listTvArticles,
                heading: 'Television News Feed',
                headingIcon: 'fa fa-solid fa-tv',
                sentimentCategory: 'television',
                label: 'Television',
                seoTitle: 'Television News Feed | Barbershop Talk',
                seoDescription: "The Television News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Television and Entertainment! Explore trending TV insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Television News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Television! Explore trending TV insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/musicNews',
            name: 'music',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listMusicArticles,
                heading: 'Music News Feed',
                headingIcon: 'fa fa-solid fa-music',
                sentimentCategory: 'music',
                label: 'Music',
                seoTitle: 'Music News Feed | Barbershop Talk',
                seoDescription: "The Music News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Music and Entertainment! Explore trending Music insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The Music News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including Music! Explore trending Music insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/inTheaters',
            name: 'inTheaters',
            component: inTheaters
        },
        {
            path: '/sports/nba',
            name: 'nba',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listNbaArticles,
                heading: 'NBA News Feed',
                headingIcon: 'fa fa-solid fa-basketball',
                sentimentCategory: 'nba',
                label: 'NBA',
                widgetComponent: NbaScores,
                seoTitle: 'NBA News Feed | Barbershop Talk',
                seoDescription: "The NBA News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NBA! Explore trending NBA insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The NBA News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NBA! Explore trending NBA insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/sports/nfl',
            name: 'nfl',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listNflArticles,
                heading: 'NFL News Feed',
                headingIcon: 'fa fa-solid fa-football',
                sentimentCategory: 'nfl',
                label: 'NFL',
                widgetComponent: NflIntelligencePreview,
                seoTitle: 'NFL News Feed | Barbershop Talk',
                seoDescription: "The NFL News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NFL! Explore trending NFL insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The NFL News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NFL! Explore trending NFL insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/sports/nhl',
            name: 'nhl',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listNhlArticles,
                heading: 'NHL News Feed',
                headingIcon: 'fa fa-solid fa-hockey-puck',
                sentimentCategory: 'nhl',
                label: 'NHL',
                widgetComponent: NhlScores,
                seoTitle: 'NHL News Feed | Barbershop Talk',
                seoDescription: "The NHL News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NHL! Explore trending NHL insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The NHL News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including the NHL! Explore trending NHL insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/sports/mma',
            name: 'mma',
            component: CategoryFeed,
            props: () => ({
                listArticles: ArticleService.listMmaArticles,
                heading: 'MMA News Feed',
                headingIcon: 'fa fa-solid fa-hand-fist',
                sentimentCategory: 'mma',
                label: 'MMA',
                widgetComponent: UfcScores,
                seoTitle: 'MMA News Feed | Barbershop Talk',
                seoDescription: "The MMA News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including MMA! Explore trending MMA insights, news and connect with others in a vibrant, growing social media environment.",
                seoTwitterDescription: "The MMA News Feed | Join Barbershop Talk, where you're always prepared to hold a conversation about anything- including MMA! Explore trending MMA insights and connect with others in a vibrant, growing social media environment.",
            })
        },
        {
            path: '/sports/favorites',
            name: 'yourSports',
            component: YourSportsPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/sports/favorites/manage',
            name: 'yourSportsManage',
            component: YourSportsManagePage,
            meta: { requiresAuth: true }
        },
        {
            path: '/profile',
            name: 'profilePage',
            component: profilePage,
            meta: { requiresAuth: true }
        },
        {
            path: '/settings',
            name: 'accountSettings',
            component: AccountSettingsPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/profiles/:username',
            name: 'communityProfile',
            component: CommunityProfile
        },
        {
            path: '/:category/:title/:id',
            name: 'generalArticleWithTitle',
            component: ArticleContent
        },
        {
            path: '/the-barbershop/thought/:category/:id',
            name: 'thoughtPage',
            component: Thought
          },      
        {
            path: '/:category/:categorySpecific/:id',
            name: 'moreSpecificCategoryArticle',
            component: ArticleContent
        },   
        {
            path: '/sports/nba/:matchup/:gameId',
            name: 'nba-boxscore',
            props: true,
            component: NbaBoxScorePage
        },
        {
            path: '/sports/nhl/:matchup/:gameId',
            name: 'nhl-boxscore',
            props: true,
            component: NhlBoxScorePage
        },
        {
            path: '/ufc',
            name: 'ufc',
            component: UfcHomePage
        },
        {
            path: '/ufc/events',
            name: 'ufc-events',
            component: UfcEventsPage
        },
        {
            path: '/ufc/events/:eventId',
            name: 'ufc-event-center',
            props: true,
            component: UfcEventCenterPage
        },
        {
            path: '/ufc/fights/:fightId',
            name: 'ufc-fight-center',
            props: true,
            component: UfcFightCenterPage
        },
        {
            path: '/ufc/fighters/:fighterId',
            name: 'ufc-fighter',
            props: true,
            component: UfcFighterProfilePage
        },
        {
            path: '/ufc/rankings',
            name: 'ufc-rankings',
            component: UfcRankingsPage
        },
        // NFL intelligence product. IMPORTANT reserved static-prefix caveat:
        // NFL news articles resolve via the dynamic '/:category/:title/:id'
        // route (e.g. /nfl/example-story/12345). Vue Router ranks static
        // segments above dynamic ones, so '/nfl/games/:gameId',
        // '/nfl/teams/:teamId', etc. always win over the article route for
        // their prefixes — which also means an article whose slug is exactly
        // 'games', 'teams', 'players', 'standings', or 'power-rankings'
        // would resolve to these pages instead. Those prefixes are reserved.
        {
            path: '/nfl',
            name: 'nfl-home',
            component: NflHomePage
        },
        {
            path: '/nfl/games',
            name: 'nfl-games',
            component: NflGamesPage
        },
        {
            path: '/nfl/games/:gameId',
            name: 'nfl-game-center',
            props: true,
            component: NflGameCenterPage
        },
        {
            path: '/nfl/teams/:teamId',
            name: 'nfl-team',
            props: true,
            component: NflTeamProfilePage
        },
        {
            path: '/nfl/players/:playerId',
            name: 'nfl-player',
            props: true,
            component: NflPlayerProfilePage
        },
        {
            path: '/nfl/standings',
            name: 'nfl-standings',
            component: NflStandingsPage
        },
        {
            path: '/nfl/power-rankings',
            name: 'nfl-power-rankings',
            component: NflPowerRankingsPage
        },
        {
            path: '/:team1/:team2/:date/boxscore/:eventId',
            name: 'Box-Score',
            props: true,
            component: BoxScore
        },
        {
            path: '/searchArticles',
            name: 'searchBar',
            component: SearchArticlesMobile
        },
        {
            path: '/searchArticles/:term',
            name: 'searchBarDesktop',
            component: SearchArticlesDesktop
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout,
            meta: {
              requiresAuth: false
            }
          },    
        {
            path: '/login',
            name: 'login',
            component: loginPage,
            meta: {
                requiresAuth: false
              }
        },
        {
            path: '/register',
            name: 'register',
            component: registerPage,
            meta: {
                requiresAuth: false
              }
        },
        {
            path: '/images/:imageName',
            name: 'images',
            component: imagesRender
        },
        {
            path: '/thefeed/:subject',
            name: 'rssfeed',
            component: RssFeed
        },
        {
            path: '/404',
            name: '404',
            component: NotFoundPage
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: ForgetPassword
        },
        {
            path: '/new-password',
            name: 'newPassword',
            component: UpdatePassword
        },
        {
            path: '/notification-preferences',
            redirect: '/notifications'
        },
        {
            path: '/newsletter',
            name: "newsletterPage",
            component: NewletterPage
        },
        {
            path: '/notifications',
            name: 'NotificationCenter',
            component: NotificationCenter,
            meta: { requiresAuth: true }
        },
        {
            path: '/pricing',
            name: 'pricingPage',
            component: PricingPage
        },
        {
            path: '/subscription/success',
            name: 'subscriptionSuccess',
            component: SubscriptionSuccess,
            meta: { requiresAuth: true }
        },
        {
            path: '/about',
            name: 'aboutPage',
            component: AboutPage,
        },
        {
            path: '/methodology',
            name: 'methodologyPage',
            component: MethodologyPage,
        },
        {
            path: '/under-sniper',
            name: 'underSniperPage',
            component: UnderSniperPage,
        },
        {
            path: '/picks',
            name: 'sniperPicksPage',
            component: SniperPicksPage,
            meta: {
                title: "The Board | The Under Sniper",
            },
        },
        {
            path: '/editorial-policy',
            name: 'editorialPolicyPage',
            component: EditorialPolicyPage,
        },
        {
            path: '/privacy',
            name: 'privacyPolicyPage',
            component: PrivacyPolicyPage,
        },
        {
            path: '/terms',
            name: 'termsOfServicePage',
            component: TermsOfServicePage,
        },
        {
            path: '/community-guidelines',
            name: 'communityGuidelinesPage',
            component: CommunityGuidelinesPage,
        },
        {
            path: '/how-sentiment-works',
            name: 'howSentimentWorksPage',
            component: HowSentimentWorksPage,
        },
        {
            path: '/how-bias-analysis-works',
            name: 'howBiasWorksPage',
            component: HowBiasWorksPage,
        },
        {
            path: '/how-blindspots-work',
            name: 'howBlindspotWorksPage',
            component: HowBlindspotWorksPage,
        },
        {
            path: '/challenge-your-view',
            name: 'challengeYourViewPage',
            component: ChallengeYourViewPage,
        },
        {
            path: '/admin/moderation',
            component: () => import('../views/admin/ModerationLayout.vue'),
            meta: { requiresAuth: true, requiresModerator: true },
            children: [
                {
                    path: '',
                    name: 'moderationQueue',
                    component: () => import('../views/admin/ModerationQueue.vue'),
                    meta: { requiresAuth: true, requiresModerator: true },
                },
                {
                    path: 'reports/:reportId',
                    name: 'moderationReport',
                    component: () => import('../views/admin/ModerationReport.vue'),
                    meta: { requiresAuth: true, requiresModerator: true },
                },
                {
                    path: 'users/:userId',
                    name: 'moderationUser',
                    component: () => import('../views/admin/ModerationUser.vue'),
                    meta: { requiresAuth: true, requiresModerator: true },
                },
            ],
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: NotFoundPage
        }

    ]

    // DEV/TEST ONLY: embed certification gallery. The literal NODE_ENV check
    // lets webpack drop this block (and the chunk) from production builds, so
    // the route does not exist in the website or iOS bundle.
    if (process.env.NODE_ENV !== 'production') {
        routes.unshift(
            {
                path: '/dev/embeds',
                name: 'devEmbedGallery',
                component: () => import('../views/dev/EmbedFixtureGallery.vue'),
            },
            {
                path: '/dev/embeds/selftest',
                name: 'devEmbedSelfTest',
                component: () => import('../views/dev/EmbedSelfTestPage.vue'),
            },
        );
    }

    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes,
        scrollBehavior (to, from, savedPosition) {
            if (savedPosition) {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve(savedPosition)
                }, 500) 
              })
            }
            if (to.meta.persistScroll) {
                const saved = localStorage.getItem('feedScrollPosition');
                return new Promise((resolve) => {
                    setTimeout(() => {
                      resolve({ left: 0, top: Number(saved) })
                    }, 500);
                })
              } 
            
            else {
              return { left: 0, top: 0 }
            }
          }
    
    })

    router.beforeEach((to, from, next) => {
        const token = store.state.token;
        const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
        const gate = resolveAuthGate({
          hasToken: Boolean(token),
          tokenExpired: Boolean(token) && isJwtExpired(token),
          requiresAuth,
          path: to.path,
        });
        if (gate.logout) {
          store.commit('LOGOUT');
        }
        if (gate.redirect) {
          next(gate.redirect);
          return;
        }
        if (to.matched.some(x => x.meta.requiresModerator)) {
          const dest = resolveModeratorNavigation({
            token: store.state.token,
            user: store.state.user,
          });
          if (dest === true) {
            next();
          } else {
            next(dest);
          }
          return;
        }
        next();
      });

export default router;